import { Routes } from '@angular/router';
import { Account } from './components/account/account';
import { About } from './components/about/about';
import { AdminPanel } from './components/admin-panel/admin-panel';
import { AuthCallback } from './components/auth-callback/auth-callback';
import { Contact } from './components/contact/contact';
import { Dashboard } from './components/dashboard/dashboard';
import { ErrorPage } from './components/error-page/error-page';
import { ForgotPassword } from './components/forgot-password/forgot-password';
import { Home } from './components/home/home';
import { Legal } from './components/legal/legal';
import { Login } from './components/login/login';
import { MyFiles } from './components/my-files/my-files';
import { ModerationOffers } from './components/moderation-offers/moderation-offers';
import { Plans } from './components/plans/plans';
import { PostOffer } from './components/post-offer/post-offer';
import { Security } from './components/security/security';
import { Settings } from './components/settings/settings';
import { Signup } from './components/signup/signup';
import { adminGuard, authGuard, guestGuard, moderatorGuard } from './core/auth.guard';

export const routes: Routes = [
  { path: '', component: Home, pathMatch: 'full' },
  { path: 'login', component: Login, canActivate: [guestGuard] },
  { path: 'auth/callback', component: AuthCallback },
  { path: 'forgot-password', component: ForgotPassword },
  { path: 'signup', component: Signup },
  { path: 'plans', component: Plans },
  { path: 'about', component: About },
  { path: 'contact', component: Contact },
  { path: 'post-offer', component: PostOffer },
  { path: 'mentions-legales', component: Legal, data: { kind: 'mentions-legales' } },
  { path: 'terms', component: Legal, data: { kind: 'cgu' } },
  { path: 'cgu', component: Legal, data: { kind: 'cgu' } },
  { path: 'cgv', component: Legal, data: { kind: 'cgv' } },
  { path: 'privacy', component: Legal, data: { kind: 'privacy' } },
  { path: 'data-deletion', component: Legal, data: { kind: 'data-deletion' } },
  { path: 'cookies', component: Legal, data: { kind: 'cookies' } },
  { path: 'accessibility', component: Legal, data: { kind: 'accessibility' } },
  { path: 'withdrawal', component: Legal, data: { kind: 'withdrawal' } },
  { path: 'dashboard', component: Dashboard, canActivate: [authGuard] },
  { path: 'admin', component: AdminPanel, canActivate: [adminGuard] },
  { path: 'moderation/offers', component: ModerationOffers, canActivate: [moderatorGuard] },
  { path: 'account', component: Account, canActivate: [authGuard] },
  { path: 'security', component: Security, canActivate: [authGuard] },
  { path: 'settings', component: Settings },
  { path: 'files', component: MyFiles, canActivate: [authGuard] },
  { path: '403', component: ErrorPage, data: { code: '403' } },
  { path: '404', component: ErrorPage, data: { code: '404' } },
  { path: '500', component: ErrorPage, data: { code: '500' } },
  { path: '**', redirectTo: '404' }
];
